import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Card, CardBody, Label, Modal, Form, Input, FormFeedback, FormGroup } from 'reactstrap';
import { Table, Thead, Tbody, tr, Th, td } from "react-super-responsive-table"
import PropTypes from "prop-types";
import withRouter from 'components/Common/withRouter';
import { useSelector, useDispatch } from "react-redux";
import { MoonLoader } from "react-spinners";
import * as url from "./../../helpers/url_helper"
import Select from "react-select"
import moment from 'moment';
import { logoutUserRetrait } from "../../store/actions";

const Retrait = props => {
    document.title = "Connexion | Abidjan DAI Application";
    const user= JSON.parse(localStorage.getItem("userRetrait"));
    const dispatch = useDispatch();
    const [hasCamera, setHasCamera] = useState(false);
    const [showButton, setShowButton] = useState(true);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(null);
    const [typePhotos, setTypePhotos] = useState([{label: "Pièce", value: "piece"}, {label: "Colis", value: "colis"}]);
    const [typePhoto, setTypePhoto] = useState(null);
    const [msgError, setMsgError] = useState("")
    const [opCode, setOpCode] = useState("")
    const [phone, setPhone] = useState("")
    const [capturedPhoto, setCapturedPhoto] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [modal_opera, setmodal_opera] = useState(false)
    const [detail, setdetail] = useState(null);
    const [selectedOpera, setSelectedOpera] = useState(null);
    const [operation, setOperation] = useState(null);
    const [operations, setOperations] = useState([]);
    const [allOperations, setAllOperations] = useState([]);
    const optionOperation = [ { options: operations } ]
    const handleOperation= (event)=>{ setSelectedOpera(event); setOperation(event.value); setOpCode(event.label); setdetail(event.data); setTimeout(() => { tog_get_opera() }, 100); }
    const handleTypePhoto= (event)=>{ setTypePhoto(event); }

    const loadOperations=(search="")=> {
        let opArray= [] //[{label: "Toutes les agences", value: ''}];
        fetch(url.BACKEND_URL+"/operation?code="+search, {
            method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
        .then((response) => response.json())
        .then((responseJson) => { 
            if (responseJson.status==200) { 
            opArray=[...opArray, ...responseJson.data.map(item=>({ label: item.opCode, value: item.opId, data: item }))]
            setAllOperations(responseJson.data)
            setOperations(opArray)
        } else {  }
        }) .catch((error) => {  });
    };

    const getOperation=(item=null)=> {
    return (
        <Row>
          <Col xl="12">
            <div className="table-rep-plugin">
              <div className="table-basic mb-0">
              <Table style={{ fontSize: 16 }}>
                <Tbody>
                    {item.opPickupWithoutDoc ? 
                        (<tr style={{ background: "#09c729", }}><td style={{ color: "white"  }}><strong style={{ fontSize: 20 }}>Retrait sans pièce</strong></td></tr>)
                    : (<tr style={{ background: "rgba(214, 104, 9, 1)", }}><td style={{ color: "white"  }}><strong style={{ fontSize: 20 }}>Retrait avec pièce</strong></td></tr>)
                    }
                    <tr><td>Départ <br/><strong>{item.opAgexp.agNom}</strong></td></tr>
                    <tr><td>Agence Bénéficiaire <br/><strong>{item.opAgdest.agNom}</strong></td></tr>
                    <tr><td>Expéditeur<br/><strong>{item.opExp} ({item.opPhonexp})</strong></td></tr>
                    <tr><td>Bénéficiaire<br/><strong>{item.opDest} ({item.opDestphone})</strong></td></tr>
                    <tr><td>Code du colis<br/><strong>{item.opCode}</strong></td></tr>
                    <tr><td>Bordereau<br/><strong>{item.opBord.bordCode}</strong></td></tr>
                    <tr><td>Car<br/><strong>{item.opBord.bordCar ? item.opBord.bordCar: null}</strong></td></tr>
                    <tr><td>Heure d'expédition<br/><strong>{item.opBord.bordCar ? moment(item.opBord.bordHeure).format("HH:mm"): null}</strong></td></tr>
                    <tr><td>Emballage<br/><strong>{item.detail[0].opdEmbal.embalLibelle}</strong></td></tr>
                    <tr><td>Nature<br/><strong>{item.detail[0].opdNature.natLibelle}</strong></td></tr>
                    <tr><td>Valeur<br/><strong>{item.opValeur} FCFA</strong></td></tr>
                    <tr><td>Frais<br/><strong>{item.opFrais} FCFA</strong></td></tr>
                    <tr><td>
                            <button style={{ width: "100%" }} className="btn btn-primary btn-lg waves-effect waves-light flex-fill" onClick={()=>tog_get_opera()} type="button"> 
                                Continuer
                            </button>
                        </td>
                    </tr>
                </Tbody>
              </Table>
              </div>
            </div>
          </Col>
        </Row>);};
    function tog_get_opera() {setmodal_opera(!modal_opera); removeBodyCss() }
    function removeBodyCss() { document.body.classList.add("no_padding") }
    const useDebounce = (callback, delay) => {
        const [debounceTimer, setdebounceTimer] = useState(null);
        const debouncedCallback = useCallback((...args) => {
            if (debounceTimer) { clearTimeout(debounceTimer); }
            
            const newTimer = setTimeout(() => { callback(...args); }, delay);
            setdebounceTimer(newTimer);
        }, [callback, delay, debounceTimer]);

        return debouncedCallback;
    };
    const debouncedSearch = useDebounce(loadOperations, 500);
    const handleInputChange = (inputValue) => {
        // Recherche immédiate pour chaîne vide ou après 2 caractères
        if (inputValue.length === 0) { loadOperations(); } 
        else if (inputValue.length >= 2) { debouncedSearch(inputValue); }
    };

    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
            if (videoRef.current) { videoRef.current.srcObject = stream; }
            setHasCamera(true); setError(null);
        } catch (err) { setError("Erreur lors de l'accès à la caméra: " + err.message); setHasCamera(false); }
    };

    const stopCamera = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const stream = videoRef.current.srcObject;
            const tracks = stream.gettracks();
            tracks.forEach(track => track.stop());
            videoRef.current.srcObject = null;
        }
    };

    useEffect(() => { startCamera(); return () => { stopCamera(); }; }, []);
    useEffect(() => { loadOperations(""); setPhone(user?.usPhone) }, []);

    const verifData = () => {
        if (phone.trim() === "" || phone.length < 8) { setMsgError("Contact agent incorrect"); return false; }
        else if (opCode.trim() === "") { setMsgError("Code de colis obligatoire");  return false; }
        else { return true; }
    }

    const takePhoto = () => {
        const canvas = canvasRef.current;
        const video = videoRef.current;
        const context = canvas.getContext("2d");
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageDataUrl = canvas.toDataURL("image/png");
        setCapturedPhoto(imageDataUrl);
        setShowPreview(true);
        setShowButton(false);
    };

    const confirmPhoto = () => {
        const canvas = canvasRef.current;
        
        canvas.toBlob(async (blob) => {
            if (!blob) return;
            const file = new File([blob], "photo.png", { type: "image/png" });
            const formData = new FormData();
            formData.append("file", file);
            
            if (verifData()) {
                setLoader(true);
                setShowPreview(false);
                fetch(url.BACKEND_URL + "/operation/pickup-withimg?opCode=" + opCode + "&phone=" + phone+ "&type=" + typePhoto.value, 
                { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
                .then((response) => response.json())
                .then((responseJson) => { 
                    console.log(responseJson.data);
                    if (responseJson.status == 200) { 
                        setLoader(false);
                        setShowButton(true);
                        props.router.navigate('/success-retrait', {state: {operation: responseJson.data, type: typePhoto.value}});
                    } else { 
                        setLoader(false); setShowButton(true); setMsgError(responseJson.message); 
                    }
                }) 
                .catch((error) => { setLoader(false); setShowButton(true); setMsgError("Erreur de connexion"); });
            }
        }, "image/png");     
    };

    const retakePhoto = async () => { setCapturedPhoto(null); setShowPreview(false); setShowButton(true); setMsgError(""); setHasCamera(false); await startCamera(); };

    const handleLogout = () => {
        dispatch(logoutUserRetrait());
        props.router.navigate('/login-retrait');
    };

    return (
        <React.Fragment>
            <Modal size="xl" isOpen={modal_opera} toggle={() => { tog_get_opera() }}>
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="myLargeModalLabel">Vérification colis {detail?.opCode}</h5>
                </div>
                {detail && getOperation(detail)}
            </Modal>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={12} lg={12} xl={12}>
                            <Card className="overflow-hidden">
                                <CardBody>
                                    <div className='col-lg-12'>
                                        <button className="btn btn-danger btn-lg w-md waves-effect waves-light" 
                                                onClick={handleLogout} style={{ width: '100%' }}  type="button"
                                        > 
                                        <i className='fa fa-pull-off'></i> Se déconnecter</button>
                                    </div>
                                </CardBody>
                                <CardBody className="pt-0">
                                    <div className="p-3">
                                        <h4 className="text-muted font-size-18 mb-1 text-center">Retrait de colis</h4>
                                        <Form className="form-horizontal mt-2">
                                            <div className="mb-3">
                                                <Input name="phone" className="form-control" placeholder="Numéro de l'agent" type="number" value={user.usPhone} readOnly={true} />
                                            </div>
                                            {/* <div className="mb-3">
                                                <Input name="opCode" className="form-control" placeholder="Code colis" type="text" onChange={(event) => setOpCode(event.target.value)} value={opCode}/>
                                            </div> */}
                                            <Col xl="12">
                                                <FormGroup className="mb-4">
                                                    <div className="mb-3">
                                                    <Label>Sélectionner l'opération</Label>
                                                    <Select
                                                        value={selectedOpera}
                                                        onChange={handleOperation}
                                                        onInputChange={handleInputChange}
                                                        options={optionOperation}
                                                        isLoading={isLoading}
                                                        placeholder="Rechercher une opération..."
                                                        noOptionsMessage={({ inputValue }) => 
                                                            inputValue.length < 2 ? 
                                                            "Tapez au moins 2 caractères" : 
                                                            "Aucune opération trouvée"
                                                        }
                                                        loadingMessage={() => "Recherche en cours..."}
                                                        classNamePrefix="select2-selection"
                                                        isClearable
                                                        isSearchable
                                                        filterOption={null}
                                                    />
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="12">
                                                <FormGroup className="mb-4">
                                                    <div className="mb-3">
                                                    <Label>Type de photo</Label>
                                                    <Select
                                                        value={typePhoto}
                                                        onChange={handleTypePhoto}
                                                        options={typePhotos}
                                                        placeholder="Rechercher une opération..."
                                                        classNamePrefix="select2-selection"
                                                    />
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            
                                            <Row>
                                                {error && <p className="text-danger">{error}</p>}
                                                {!hasCamera && !error && <p>Chargement de la caméra...</p>}
                                                
                                                {/* Caméra ou prévisualisation */}
                                                {!showPreview ? (
                                                    <video ref={videoRef} autoPlay playsInline muted style={{ width: 800, maxHeight: 600 }} />
                                                ) : (
                                                    <div className="text-center">
                                                        <h5 className="mb-3">Prévisualisation de la photo</h5>
                                                        <img src={capturedPhoto} alt="Photo capturée" style={{width: 300, objectFit: 'cover', border: '2px solid #ddd', borderRadius: '8px'}} />
                                                    </div>
                                                )}
                                                
                                                <canvas ref={canvasRef} width={800} height={600} style={{ display: "none" }}/>
                                            </Row>
                                            
                                            {/* Boutons d'action */}
                                            {hasCamera && (
                                                <Row className="mb-3 mt-4">
                                                    <div className="col-12">
                                                        {showButton && !showPreview && (
                                                            <button 
                                                                className="btn btn-primary btn-lg w-md waves-effect waves-light" 
                                                                onClick={takePhoto} 
                                                                style={{ width: '100%' }} 
                                                                type="button"
                                                            > 
                                                                <i className='fa fa-camera'></i> Prendre photo
                                                            </button>
                                                        )}
                                                        
                                                        {showPreview && (
                                                            <div className="d-flex gap-2">
                                                                <button 
                                                                    className="btn btn-secondary btn-lg waves-effect waves-light flex-fill" 
                                                                    onClick={retakePhoto}
                                                                    type="button"
                                                                > 
                                                                    <i className='fa fa-redo'></i> Reprendre
                                                                </button>
                                                                <button 
                                                                    className="btn btn-success btn-lg waves-effect waves-light flex-fill" 
                                                                    onClick={confirmPhoto}
                                                                    type="button"
                                                                > 
                                                                    <i className='fa fa-check'></i> Confirmer
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Row>
                                            )}
                                            
                                            <Row>
                                                {loader && (
                                                    <div className="text-center">
                                                        <MoonLoader />
                                                        <p className="mt-2">Envoi en cours...</p>
                                                    </div>
                                                )}
                                            </Row>
                                            
                                            <Row>
                                                {msgError && (
                                                    <strong style={{ fontSize: 17 }} className='text-danger'>
                                                        {msgError}
                                                    </strong>
                                                )}
                                            </Row>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="mt-5 text-center">
                                © {new Date().getFullYear()} UE DIGOTAL 
                                <span className="d-none d-sm-inline-block"> - 
                                    <i className="mdi mdi-copyright text-primary"></i> by 
                                    <a href='https://createsarl.com' target='_blank' rel="noopener noreferrer"> CREATED SARL.</a>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Retrait);

Retrait.propTypes = {
    history: PropTypes.object,
};